import { render, staticRenderFns } from "./about_picc.vue?vue&type=template&id=c9a5bde4&"
import script from "./about_picc.vue?vue&type=script&lang=js&"
export * from "./about_picc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports